import { Dispatch, useEffect } from 'react';
import { resetAddDocumentFilesState } from '../redux/general/sliceFileUpload';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useEnqueueSnackbar } from './useEnqueueSnackbar';
import { ToastSeverity } from '../components/General/Toast/Toast';
import { IAppReduxStore } from '../redux/store';

export const useAddFiles = () => {
    const dispatch: Dispatch<unknown> = useDispatch();
    const { t } = useTranslation('translations', { keyPrefix: 'projectView' });
    const enqueueSnackbar = useEnqueueSnackbar();

    const addDocumentFilesState = useSelector(
        (store: IAppReduxStore) => store.fileUpload.addDocumentFilesDialogState,
    );

    useEffect(() => {
        const { result, error } = addDocumentFilesState;

        if (result) {
            enqueueSnackbar(t(`addFilesSuccess`, { count: result }), {
                severity: ToastSeverity.Success,
            });
        }
        if (error) {
            enqueueSnackbar(t(`addFilesError`, { count: error.count, total: error.total }), {
                severity: ToastSeverity.Error,
            });
        }
        if (result || error) {
            dispatch(resetAddDocumentFilesState());
        }
    }, [addDocumentFilesState]);
};
